import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/main',
    pathMatch: 'full'
  },
  {
    path: 'main',
    component: LayoutComponent,
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule)
  },
  {
    path: 'tech',
    component: LayoutComponent,
    loadChildren: () => import('./pages/tech/tech.module').then(m => m.TechModule)
  },
  {
    path: 'about',
    component: LayoutComponent,
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'services',
    component: LayoutComponent,
    loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesModule)
  },
  {
    path: 'core-services',
    component: LayoutComponent,
    loadChildren: () => import('./pages/core-services/core-services.module').then(m => m.CoreServicesModule)
  },
  {
    path: 'expertise',
    component: LayoutComponent,
    loadChildren: () => import('./pages/expertise/expertise.module').then(m => m.ExpertiseModule)
  },
  {
    path: 'contact',
    component: LayoutComponent,
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    //useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
